import { http } from './client'
import type { SettingsResponse } from '../types/api'

const BASE = '/api/v1/settings'

export const settingsApi = {
  get: (): Promise<SettingsResponse> => http.get(BASE),

  setAnthropicKey: (apiKey: string): Promise<SettingsResponse> =>
    http.patch(`${BASE}/anthropic-key`, { api_key: apiKey }),

  clearAnthropicKey: (): Promise<SettingsResponse> =>
    http.delete(`${BASE}/anthropic-key`),

  /** DEC-192: the paused-scan waiting time lives with the scan limits. */
  setArchivePausedAfterDays: (days: number): Promise<SettingsResponse> =>
    http.patch(`${BASE}/limits`, { archive_paused_after_days: days }),
}
